import { useTranslation } from 'react-i18next'

export function Onboarding() {
  const { t } = useTranslation()
  return (
    <div className="p-4 bg-muted rounded-lgm mb-4 rounded-xl">
      <h6>
        Get started
        {t('onboarding.heading')}
      </h6>
      <p>{t('onboarding.body')}</p>
    </div>
  )
}
